const thumb_swiper = new Swiper(".thumb_swiper", {
  // loop: true,
  slidesPerView: 8.5,
  freeMode: true,
});


const detail_swiper = new Swiper(".detail_swiper", {
  loop: true,
  // thumbs: {
  //   swiper: thumb_swiper,
  // },
  pagination: {
    el: ".swiper-pagination",
    type: "fraction", // 枚数表示
    // clickable: true,
  },
  // 前後の矢印
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});


const magazine_block_swiper = new Swiper(".magazine_block_swiper", {
  loop: true,

  pagination: {
    el: ".swiper-pagination",
    // type: "fraction", // 枚数表示
    clickable: true,
  },
  // 前後の矢印
});

const thumbItems = document.querySelectorAll('.thumb_swiper_pc div.thumb_swiper_pc_box');
if(thumbItems){
  thumbItems.forEach((img, index) => {
    img.addEventListener('click', () => {
      detail_swiper.slideTo(index);
    });
  });
}

// スライダーがスライドしたときも同期
detail_swiper.on('slideChange', () => {
  updateActiveThumb(detail_swiper.realIndex);
});

function updateActiveThumb(activeIndex) {
  thumbItems.forEach((item, index) => {
    if (index === activeIndex) {
      item.classList.add('active-thumb');
    } else {
      item.classList.remove('active-thumb');
    }
  });
}

// Store brightness values for each slide
const slideBrightness = {};

// New thumbnail grid functionality
const thumbGridItems = document.querySelectorAll('.thumb_item');
if(thumbGridItems.length > 0){
  thumbGridItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      // Remove active class from all thumb grid items
      thumbGridItems.forEach(thumb => thumb.classList.remove('active'));
      // Add active class to clicked item
      item.classList.add('active');
      // Switch to corresponding slide in detail swiper
      detail_swiper.slideTo(index);
      // Immediately adjust text color for the target slide
      adjustTextColorForSlide(index);
    });
  });
  
  // Set first thumb grid item as active by default
  thumbGridItems[0].classList.add('active');
  
  // Update thumb grid active state when detail swiper changes
  detail_swiper.on('slideChange', () => {
    const activeIndex = detail_swiper.realIndex;
    thumbGridItems.forEach((item, index) => {
      item.classList.remove('active');
      if (index === activeIndex) {
        item.classList.add('active');
      }
    });
    // Adjust text color based on current slide image brightness
    adjustTextColorForSlide(activeIndex);
  });
}

// Function to get brightness of image bottom-left area where text is positioned
function getImageBrightness(img) {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    canvas.width = img.naturalWidth || img.width;
    canvas.height = img.naturalHeight || img.height;
    
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    
    // Sample bottom-left area (20% of width, 20% of height from bottom-left)
    const sampleWidth = Math.floor(canvas.width * 0.2);
    const sampleHeight = Math.floor(canvas.height * 0.2);
    const startX = 0;
    const startY = canvas.height - sampleHeight;
    
    const imageData = ctx.getImageData(startX, startY, sampleWidth, sampleHeight);
    const data = imageData.data;
    
    let totalBrightness = 0;
    const pixelCount = data.length / 4;
    
    for (let i = 0; i < data.length; i += 4) {
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];
      // Calculate brightness using luminance formula
      const brightness = (0.299 * r + 0.587 * g + 0.114 * b);
      totalBrightness += brightness;
    }
    
    const avgBrightness = totalBrightness / pixelCount;
    resolve(avgBrightness);
  });
}

// Function to adjust text color for specific slide index
function adjustTextColorForSlide(slideIndex) {
  const slides = document.querySelectorAll('.detail_swiper .swiper-slide');
  if (!slides[slideIndex]) return;
  
  const img = slides[slideIndex].querySelector('img');
  const colorNameSpan = slides[slideIndex].querySelector('.img_color_name');
  
  if (!img || !colorNameSpan) return;
  
  // Check if brightness is already cached
  if (slideBrightness[slideIndex] !== undefined) {
    // Use cached brightness value
    applyTextColor(colorNameSpan, slideBrightness[slideIndex]);
  } else {
    // Calculate and cache brightness
    if (img.complete) {
      calculateAndCacheBrightness(img, colorNameSpan, slideIndex);
    } else {
      img.onload = () => calculateAndCacheBrightness(img, colorNameSpan, slideIndex);
    }
  }
}

// Function to calculate brightness and cache it
function calculateAndCacheBrightness(img, colorNameSpan, slideIndex) {
  getImageBrightness(img).then(brightness => {
    // Cache the brightness value
    slideBrightness[slideIndex] = brightness;
    // Apply the text color
    applyTextColor(colorNameSpan, brightness);
  }).catch(() => {
    // Fallback brightness value
    slideBrightness[slideIndex] = 50; // Assume dark image
    applyTextColor(colorNameSpan, 50);
  });
}

// Function to apply text color based on brightness
function applyTextColor(colorNameSpan, brightness) {
  if (brightness < 128) {
    colorNameSpan.style.setProperty('color', '#ffffff', 'important');
  } else {
    colorNameSpan.style.setProperty('color', '#000000', 'important');
  }
}

// Pre-calculate brightness for all slides when page loads
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const slides = document.querySelectorAll('.detail_swiper .swiper-slide');
    slides.forEach((slide, index) => {
      const img = slide.querySelector('img');
      const colorNameSpan = slide.querySelector('.img_color_name');
      
      if (img && colorNameSpan) {
        if (img.complete) {
          calculateAndCacheBrightness(img, colorNameSpan, index);
        } else {
          img.onload = () => calculateAndCacheBrightness(img, colorNameSpan, index);
        }
      }
    });
  }, 100);
});